module.exports = __webpack_public_path__ + "img/return.6c66e1d5.svg";